import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { chatKeys } from '../../keys'
import chatService from '../services'

import type { components } from '@/schema'

type CreateQuickResponseDto = components['schemas']['CreateQuickResponseDto']
type UpdateQuickResponseDto = components['schemas']['UpdateQuickResponseDto']

export function useQueryQuickResponses() {
	return useQuery({
		queryKey: chatKeys.quickResponses(),
		queryFn: () => chatService.getQuickResponses(),
	})
}

export function useMutationCreateQuickResponse() {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (data: CreateQuickResponseDto) =>
			chatService.createQuickResponse(data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: chatKeys.quickResponses() })
			toast.success('สร้างข้อความด่วนเรียบร้อยแล้ว')
		},
		onError: () => {
			toast.error('สร้างข้อความด่วนไม่สำเร็จ กรุณาลองใหม่อีกครั้ง')
		},
	})
}

export function useMutationUpdateQuickResponse() {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ({ id, data }: { id: string; data: UpdateQuickResponseDto }) =>
			chatService.updateQuickResponse(id, data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: chatKeys.quickResponses() })
			toast.success('แก้ไขข้อความด่วนเรียบร้อยแล้ว')
		},
		onError: () => {
			toast.error('แก้ไขข้อความด่วนไม่สำเร็จ กรุณาลองใหม่อีกครั้ง')
		},
	})
}

export function useMutationDeleteQuickResponse() {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (id: string) => chatService.deleteQuickResponse(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: chatKeys.quickResponses() })
			toast.success('ลบข้อความด่วนเรียบร้อยแล้ว')
		},
		onError: () => {
			toast.error('ลบข้อความด่วนไม่สำเร็จ กรุณาลองใหม่อีกครั้ง')
		},
	})
}
